import React from 'react';
import { Switch } from 'react-router';
import { Route, Redirect } from 'react-router-dom';

import User from '../containers/User';

import 'styles/setup.css';

export const Setup = ({ match }) => {
  return (
    <Switch>
      <Route exact path={`${match.url}/user/:token`} component={User} />
      <Redirect to="/dashboard" />
    </Switch>
  );
};

export default Setup;
